import React, { useCallback, useEffect, useMemo, useState } from "react";

import { updateSiteHistory } from "app/_services/UserManagement/EmployeeService";
import { Modal, Button } from "react-bootstrap";

import toastr from "toastr";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiEdit3 } from "react-icons/fi";
import EmployeeSiteHistoryForm from "./EmployeeSiteHistoryForm";
import {
  employeeFormLabel,
  initialMedicalValidation,
  initialTrainingValidation,
} from "../Constant";
import { isAfter } from "app/_helpers/dateHelper";
import InitialLocationForm from "./InitialLocationForm";
import { contractorPersonFormLabel } from "../../ContractorPerson/Constant";
import { supportsHistory } from "history/DOMUtils";
import moment from "moment";

const SupportHistoryTable = ({ ticket }) => {
  console.log("ticket", ticket);
  const historyColumns = useMemo(() => {
    let data = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "assignedToUser",
        text: "Assigned To",
        sort: true,
      },
      {
        dataField: "assignedByUser",
        text: "Assigned By",
        sort: true,
        // formatter: (rowContent, row) => {
        //   {
        //     return (
        //       <div
        //       //  className="actionIconsGroup"
        //       >
        //         {row.assignedByUser?.firstName + " " + row.assignedByUser?.lastName}
        //       </div>
        //     );
        //   }
        // },
      },
      {
        dataField: "comment",
        text: "Comment",
        sort: true,
        formatter: (rowContent, row) => {
          {
            return (
              <div
              //  className="actionIconsGroup"
              >
                {row.comment}
              </div>
            );
          }
        },
      },
      {
        dataField: "createdAt",
        text: "Assigned Date",
        sort: true,
        formatter: (rowContent, row) => {
          return <div>{moment(row.createdAt).format("DD-MM-YYYY")}</div>;
        },
      },
    ];

    return data;
  }, []);
  return (
    <div>
      {/* Site History */}
      <div className="mt-2 mb-4">
        <h5>History</h5>

        <SearchBootstrapTable
          tableName={"site-history"}
          // data={siteHistoryList}
          //columns={siteHistoryColumns}
          // tableDownloadFlag={false}
          searchKey={"ticketHistoryDesktopSearch"}
          data={ticket.map((ele) => {
            return {
              ...ele,
              assignedByUser: `${
                ele.assignedByUser?.firstName + " " + ele.assignedByUser?.lastName
              }`,
              assignedToUser: `${
                ele.assignedToUser?.firstName + " " + ele.assignedToUser?.lastName
              }`,
            };
          })}
          columns={historyColumns}
          //  tableKey={"ticketHistoryTableKey"}
          tableDownloadFlag={false}
        />
      </div>
    </div>
  );
};

export default SupportHistoryTable;
